module.exports = __webpack_public_path__ + "img/wwwwq.a39b7f49.jpg";